
import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { cn } from "./lib/utils";
import Home from "./components/Homepage";
import Projects from "./components/Projects";
import Education from "./components/Education";
import "./index.css";

function App() {
  const [activeSection, setActiveSection] = useState("home");
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (sectionId) => {
    setActiveSection(sectionId);
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const navItems = [
    { id: "home", label: "ʜᴏᴍᴇ" },
    { id: "projects", label: "ᴘʀᴏᴊᴇᴄᴛꜱ" },
    { id: "education", label: "ᴇᴅᴜᴄᴀᴛɪᴏɴ" }
  ];

  return (
    <div className="relative min-h-screen overflow-auto scroll-smooth">
      <motion.nav
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.5 }}
        className={cn(
          "fixed top-0 left-0 w-full z-[9999] transition-all duration-300",
          isScrolled
            ? "bg-black/50 backdrop-blur-md border-b border-white/10"
            : "bg-black/30 backdrop-blur-sm"
        )}
      >
        <div className="max-w-screen-xl mx-auto px-4">
          <div className="flex justify-center items-center h-16">
            <ul className="flex items-center space-x-2 sm:space-x-4 md:space-x-8">
              {navItems.map((item) => (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavClick(item.id);
                    }}
                    className={cn(
                      "relative px-3 py-2 text-sm sm:text-base transition-colors duration-200",
                      "hover:text-white/90 cursor-pointer",
                      activeSection === item.id
                        ? "text-white"
                        : "text-white/70"
                    )}
                  >
                    {item.label}
                    {activeSection === item.id && (
                      <motion.div
                        layoutId="activeSection"
                        className="absolute bottom-0 left-0 right-0 h-0.5 bg-white"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      />
                    )}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </motion.nav>

      {/* Sections */}
      <div id="home">
        <Home />
      </div>
      <div id="projects">
        <Projects />
      </div>
      <div id="education">
        <Education />
      </div>
    </div>
  );
}

export default App;